import axios from 'axios';

const STATE_UNLOCKED = 1;
const STATE_LOCKED = 0;

const state = {
  channel: null,
  code: null,
  state: 0,
  host_id: null,
  members: [],
  votes: {},
  can_update: true
};

const getters = {
  vote(state, getters, rootState) {
    return state.votes.hasOwnProperty(rootState.user.id)
      ? state.votes[rootState.user.id]
      : null;
  }
};

const actions = {
  /**
   * Initialize game state, used when (re)loading the page
   */
  initialize({commit, state}, data) {
    commit('initGame', data);
  },

  update({commit, state}) {
    if (!state.can_update) {
      return;
    }

    axios.get(`/api/game/${state.code}`).then(({data}) => {
      commit('updateGame', data.data);
    }).catch((error) => {
      console.error(error);
    });
  },

  /**
   * Join websocket (presence) channel
   */
  joinChannel({commit, state}, channel) {
    commit('setChannel', channel);
  },

  /**
   * Leave websocket (presence) channel
   */
  leaveChannel({commit, state}) {
    commit('setChannel', null);
  },

  /**
   * Add joined member to list of members
   */
  addMember({commit, state}, member) {
    commit('addMember', member);
  },

  /**
   * Remove member from list of members
   */
  removeMember({commit, state}, member) {
    commit('removeMember', member);
  },

  kickMember({commit, status}, member) {
    axios.post(`/api/game/${state.code}/kick`, {member_id: member.id})
      .then((response) => {
        commit('kickMember', member);
      })
      .catch((err) => {
        console.log(err)
      });
  },

  /**
   * Cast vote for authenticated user
   */
  castVote({commit, dispatch, state, rootState}, vote) {
    let currentVote = state.votes[rootState.user.id];

    commit('castVote', {
      user: rootState.user,
      vote: vote
    });

    axios.post(`/api/game/${state.code}/vote`, {vote}).then(() => {
      dispatch('channel/whisperUser', {
        'event': 'UserCastedVote',
        'data': {user: {id: rootState.user.id}, vote: vote}
      }, {root: true});
    }).catch(() => {
      if (currentVote) {
        commit('castVote', {
          user: rootState.user,
          vote: currentVote
        });
      } else {
        commit('withdrawVote', rootState.user);
      }
    });
  },

  /**
   * Withdraw vote for authenticated user
   */
  withdrawVote({commit, state, rootState}) {
    let currentVote = state.votes[rootState.user.id];
    commit('withdrawVote', rootState.user);
    axios.delete(`/api/game/${state.code}/vote`).catch(() => {
      commit('castVote', {vote: currentVote, user: rootState.user});
    })
  },


  /**
   * Save vote for member in channel
   */
  voted({commit, state}, {user, vote}) {
    commit('castVote', {
      user: user,
      vote: vote
    })
  },

  /**
   * Withdraw vote for member in channel
   */
  unvoted({commit, state}, user) {
    commit('withdrawVote', user);
  },


  /**
   * Request activation of lock on game
   */
  activateLock({commit, state}) {
    axios.post(`/api/game/${state.code}/lock`).catch((err) => {
      // set error message
    });
  },

  /**
   * Request de-activation of lock on game
   */
  deactivateLock({commit, state}) {
    axios.delete(`/api/game/${state.code}/lock`).catch((err) => {
      // set error message
    });
  },


  /**
   * Lock game and update votes
   */
  lock({commit, state}, votes) {
    commit('lock');
    commit('setVotes', votes);
  },

  /**
   * Unlock game and reset votes
   */
  unlock({commit, state}) {
    commit('unlock');
    commit('setVotes', {});
  }
};

const mutations = {
  initGame(state, game) {
    state.code = game.code;
    state.state = game.state;
    state.host_id = game.host_id;
    state.votes = Array.isArray(game.votes) && game.votes.length === 0 ? {} : game.votes;
    state.members = game.members;

    // Do not allow game updates when game has just been initialized
    // This prevents loading the game from the API on every page load/refresh
    state.can_update = false;
    setTimeout(() => {
      state.can_update = true;
    }, 1500);
  },
  updateGame(state, game) {
    state.state = game.state;
    state.votes = Array.isArray(game.votes) && game.votes.length === 0 ? {} : game.votes;
    state.members = game.members;
  },
  setChannel(state, channel) {
    state.channel = channel;
  },

  addMember(state, member) {
    state.members.push(member);
  },
  removeMember(state, member) {
    state.members = state.members.filter((item) => item.id !== member.id);
  },
  castVote(state, {user, vote}) {
    const votes = {...state.votes};
    votes[user.id] = vote;
    state.votes = votes;
  },
  withdrawVote(state, user) {
    const votes = {...state.votes};
    delete votes[user.id];
    state.votes = votes;
  },

  lock(state) {
    state.state = STATE_LOCKED;
  },
  unlock(state) {
    state.state = STATE_UNLOCKED;
  },

  setVotes(state, votes) {
    state.votes = votes;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
